import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_inventory_by_location_lotService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { location_id: number, lot_id: number, packaged_id: number }): 
  Promise<{ result: { LocationId?: number, LotId?: number, PackagedId?: number, ActivePackagedAmount?: number, AvailablePackagedAmount?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.location_id)) {
      $missingRequiredInParams.push('\'location_id\'');
    }
    if (isNil($inParams.lot_id)) {
      $missingRequiredInParams.push('\'lot_id\'');
    }
    if (isNil($inParams.packaged_id)) {
      $missingRequiredInParams.push('\'packaged_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      location_id: number, lot_id: number, packaged_id: number    }) {
        if(isNil($inParams.location_id)) {
          return true; 
        }
        if(isNil($inParams.lot_id)) {
          return true; 
        }
        if(isNil($inParams.packaged_id)) {
          return true; 
        }
      return false;
    }
}
